import { render, staticRenderFns } from "./Lgx240155175900151808.vue?vue&type=template&id=2865b514&scoped=true&"
import script from "./Lgx240155175900151808.vue?vue&type=script&lang=js&"
export * from "./Lgx240155175900151808.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240155175900151808.vue?vue&type=style&index=0&id=2865b514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865b514",
  null
  
)

export default component.exports